import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

export interface HeaderThemeProps {
  customMainColor?: string;
  showCartLink: boolean;
  customLogoWidth?: string;
}
const styles: ComponentStylesProps<HeaderThemeProps> = {
  header: ({ customMainColor }) => ({
    letterSpacing: '0.02rem',
    color: customMainColor || colors.neutral[900],
    maxHeight: '6.5rem',
    position: 'relative',
    zIndex: '11',

    [breakpoints.md.down]: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
    },
  }),
  desktopHeaderWrapper: () => ({
    display: 'flex',
    alignItems: 'center',
    height: '6.4rem',
    boxShadow: '4px 7px 4px -4px rgba(0, 0, 0, 0.16)',
    backgroundColor: colors.neutral.white,
  }),
  mobileHeaderWrapper: ({ customMainColor }) => ({
    backgroundColor: colors.neutral.white,
    color: customMainColor || colors.neutral[700],
    boxShadow: '4px 7px 4px -4px rgba(0, 0, 0, 0.16)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 2.4rem',
    boxSizing: 'border-box',
    height: '6.4rem',
    position: 'fixed',
    width: '100vw',
    top: 0,
  }),

  // Desktop media
  '@media(max-width:840px)': {
    // MAKE IT ONLY AS FUNCTION, otherwise styles will not be applied
    desktopHeaderWrapper: () => ({
      display: 'none',
    }),
  },

  // Mobile media
  '@media(min-width:841px)': {
    // MAKE IT ONLY AS FUNCTION, otherwise styles will not be applied
    mobileHeaderWrapper: () => ({
      display: 'none',
    }),
  },

  mobileScreenLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileScreenLogo: ({ customLogoWidth }) => ({
    width: customLogoWidth || '35rem',
    maxHeight: '5.2rem',
    [breakpoints.md.down]: {
      width: '70%',
      margin: '0 auto',
    },
  }),
  baseSection: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0.6rem 0rem',
    boxSizing: 'border-box',
    height: '100%',
  },
  navigation: {
    display: 'flex',
    flexGrow: 2,
    justifyContent: 'space-between',
  },
  headerLogoWrapper: ({ customMainColor }) => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: {
      right: '2.4rem',
      left: '2.4rem',
    },
    borderRight: `0.1rem solid ${customMainColor || colors.neutral[900]}`,
  }),
  desktopScreenLogo: ({ customLogoWidth }) => ({
    maxHeight: '5.2rem',
    width: customLogoWidth || '35rem',
  }),
  pagesLinksBlock: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    paddingLeft: '4.3rem',
  },
  mobileHomeLink: {
    textDecoration: 'none',
    color: 'inherit',
  },
  link: ({ customMainColor }) => ({
    color: customMainColor || colors.neutral[900],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  }),
  contactMeButton: ({ customMainColor }) => ({
    color: customMainColor || colors.neutral[900],
    fontSize: '1.6rem',
    fontWeight: 700,
    lineHeight: '2.4rem',
  }),
  cartLink: {
    color: colors.orange[600],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  pageLink: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '4rem',
    '&:last-of-type': {
      marginRight: '0rem',
    },
  },
  pageLinkText: {
    marginLeft: '1.3rem',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 700,
    },
  },
  additionalLinksBlock: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: {
      right: '2.6rem',
    },
  },
  additionalLinksItem: ({ showCartLink }) => ({
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      borderRight: showCartLink && `0.1rem solid ${colors.neutral[300]}`,
      paddingRight: showCartLink && '2rem',
      marginRight: showCartLink && '2rem',
    },
  }),
};

const createStyles = createUseStyles(styles);
export { createStyles };
